import { Control, FieldPath, FieldValues, useController } from 'react-hook-form';
import * as Input from '@givebutter/primitives/input';
import { useWidgetFormContext } from 'components/form/WidgetFormContext';
import { twMerge } from 'tailwind-merge';
import { FormField } from './FormField';

interface FormTextInputProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  label?: string;
  description?: string;
  placeholder?: string;
  disabled?: boolean;
}

export const FormTextInput = <T extends FieldValues>({
  name,
  control,
  label,
  description,
  placeholder,
  disabled,
}: FormTextInputProps<T>) => {
  const { compact } = useWidgetFormContext();
  const {
    field: { value, onChange, onBlur, ref },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <FormField label={label} htmlFor={name} description={description} error={error?.message}>
      <Input.Root
        isError={!!error}
        disabled={disabled}
        className={twMerge(compact && 'ring-white focus-within:ring-blue-500! hover:ring-gray-300')}
      >
        <Input.Form
          id={name}
          ref={ref}
          value={value ?? ''}
          onInput={(e: React.FormEvent<HTMLInputElement>) =>
            onChange((e.target as HTMLInputElement).value)
          }
          onBlur={onBlur}
          placeholder={placeholder}
        />
      </Input.Root>
    </FormField>
  );
};
